export default __webpack_public_path__ + "static/media/Ancient Shield.51d9be8d.jpg";